import * as actionTypes from './actionTypes';

export const userSettingsRequest = () => ({ type: actionTypes.USER_SETTINGS_REQUEST });
export const userSettingsError = (payload) => ({ type: actionTypes.USER_SETTINGS_ERROR, payload });
export const userSettingsStore = (payload) => ({ type: actionTypes.USER_SETTINGS_STORE, payload });
export const setUserIsAPublish = (payload) => ({ type: actionTypes.SET_USER_IS_A_PUBLISH, payload });
export const setIsADraft = (payload) => ({ type: actionTypes.SET_IS_A_DRAFT, payload });
